import { render, staticRenderFns } from "./PlaceView.vue?vue&type=template&id=560b9eaa&"
import script from "./PlaceView.vue?vue&type=script&lang=js&"
export * from "./PlaceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports